import { createApp } from 'vue'
import App from './App.vue'

// Create and mount the Vue application
const app = createApp(App)

// Global error handler
app.config.errorHandler = (err, vm, info) => {
    console.error('Vue Error:', err)
    console.error('Component:', vm)
    console.error('Info:', info)
}

// Mount the app
app.mount('#app')